import * as React from "react";
import type { SVGProps } from "react";
const SvgArrowUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="m6.293 14.293 1.414 1.414L12 11.414l4.293 4.293 1.414-1.414L12 8.586z"
    />
  </svg>
);
export default SvgArrowUp;
